import axios from '../axios'

// 受験結果の答え合わせ詳細（admin / 担当講師 / 本人）
const getAttemptReviewApi = async (attemptId) => {
  return await axios.get(`api/lms/attempts/${attemptId}`)
}

export default getAttemptReviewApi
